import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import DonateBtn from './DonateBtn';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // Use window.pageYOffset for better cross-browser stability
      setScrolled(window.pageYOffset);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const hideThreshold = 100; 
  const isActive = (path) => location.pathname === path;

  const NavLinks = () => (
    <>
      {[
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
        { name: 'Sponsorship', path: '/sponsorship' },
        { name: 'Contact', path: '/contact' },
      ].map((link) => (
        <Link 
          key={link.path}
          to={link.path} 
          onClick={() => setIsOpen(false)} 
          className={`relative transition-all duration-300 hover:text-gh-orange py-2
            ${isActive(link.path) ? 'text-gh-orange' : 'text-gray-600'}
          `}
        >
          {link.name.toUpperCase()}
          {isActive(link.path) && (
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gh-orange rounded-full" />
          )}
        </Link>
      ))}
    </>
  );

  return (
    <header className="relative z-[100] w-full bg-white">
      {/* GHOST SPACER: 
         This invisible box stays at a fixed height (h-48 or h-64).
         It prevents the Hero section from "jumping" when the logo hides.
      */}
      <div className="hidden md:block h-64 w-full"></div>
      <div className="md:hidden h-40 w-full"></div>

      {/* THE ACTUAL NAV: Fixed to the top */}
      <div className="fixed top-0 left-0 w-full flex flex-col z-[110]">
        
        {/* TOP LOGO AREA */}
        <div 
          className={`bg-gray-50 flex items-center justify-center border-b transition-all duration-500 ease-in-out overflow-hidden
            ${scrolled > hideThreshold ? 'h-0 opacity-0 pointer-events-none' : 'h-24 md:h-48 opacity-100'}
          `}
        >
          <Link to="/" className="p-4">
            <img src="/Giving-logo.png" alt="Logo" className="h-16 md:h-32 object-contain" />
          </Link>
        </div>

        {/* LOWER STICKY BAR */}
        <div className={`bg-white border-b border-gray-200 shadow-sm w-full transition-transform duration-300`}>
          <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
            
            {/* Small Logo (appears on scroll) */}
            <div className={`transition-all duration-500 flex items-center overflow-hidden
              ${scrolled > hideThreshold ? 'w-12 opacity-100' : 'w-0 opacity-0'}
            `}>
              <Link to="/">
                <img src="/Giving-logo.png" alt="Logo Small" className="h-10 w-auto" />
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex flex-1 justify-center gap-12 font-bold text-xs tracking-[0.2em] uppercase">
              <NavLinks />
            </div>

            <div className="hidden md:block">
              <DonateBtn className="px-6 py-2 text-xs" />
            </div>

            {/* Mobile Toggle */}
            <button className="md:hidden text-gh-blue p-2 ml-auto" onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 shadow-2xl animate-in slide-in-from-top duration-300">
            <div className="flex flex-col items-center gap-6 py-8 font-bold text-gray-800 tracking-widest uppercase">
              <NavLinks />
              <DonateBtn className="w-3/4 py-3" />
            </div>
          </div>
        )}
      </div>
    </header>
  );
}